import { useEffect, useState } from "react";

import styles from "./RegisterForTest.module.scss";
import googleIcon from "assets/icons/google-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { createNewUser } from "service/AdminService";
import { postRegisterUser } from "store/slices/AdminSlice";
import Notification from "utils/Notifications";
import eye from 'assets/icons/eye.png'
import hidden from 'assets/icons/hidden.png'
import { getUserInfo, logintrash } from "service/AuthService";
import {changePinCode,  setUser } from "store/slices/UserSlice";
import tokenDecode from "utils/decode";

import { ScaleLoader } from "react-spinners";
import { Button } from "components";
import { gapi } from "gapi-script";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import { getImage } from "service/BackgroundService";
import {
  checkPinCode,
} from "service/AuthService";
import PinCode from "hooks/PinCode/PinCode";
import {
  ChangePin,
  SendDevice,
  login,
} from "service/AuthService";
import { useNavigate } from "react-router-dom";


const RegisterForTest = ({ setLoginMail, RecoverPin }) => {
  //UserInfo
  const [loader, setLoader] = useState(false);
  const [gender, setGender] = useState(null);
  const [first_name, setFirst_name] = useState(null);
  const [last_name, setLast_name] = useState(null);
  const [middle_name, setMiddle_name] = useState("");
  const [data_of_birth, setData_of_birth] = useState(null);
  const [number_phone, setNumber_phone] = useState(null);
  const [email, setEmail] = useState(null);
  const [inn, setInn] = useState(null);
  const [password, setPassword] = useState(null);
  const [checkPassword, setCheckPassword] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [datainfo, setDataInfo] = useState(false);
  const [userPinCode, setUserPinCode] = useState();
  const [pinCode, setPinCode] = useState();
  const [userId, setUserId] = useState();
  const [device, setDevice] = useState("");
  //TEST GOOGLE

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    setDevice(userAgent);
  }, []);
  let socket = null;

  const sendMessage = (message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(message);
    } else {
      console.log("CHU");
      // Handle the case when the socket is not open
    }
  };
  const signIn = async (event) => {
    event.preventDefault();
    const _auth0k = (googleUser) => {

   
    
  
      // auth2.signOut().then(function () {});
    
      async function f() {
        try {
          let profile = googleUser.getBasicProfile();
          let name = profile.getGivenName();
          let surname = profile.getFamilyName();
          let email = profile.getEmail();
         
          // let imageUrl = profile.getImageUrl();
          setEmail(email)
          setFirst_name(name)
          setLast_name(surname)
          var auth2 = gapi.auth2.getAuthInstance();
        } catch (error) {
          setNotify({
            isOpen: true,
            message:
              error.response.data.detail ||
              `Пароль ${error.response.data.password}`,
            type: "error",
            sound: "error",
          });
        }
      }
      f();
    };

    const _authErr = () => {
      setNotify({
        isOpen: true,
        message: "Ошибка авторизации",
        type: "error",
        sound: "error",
      });
    };
    const GOOGLE_AUTH = gapi.auth2.getAuthInstance();
    GOOGLE_AUTH.signIn({
      scope: "profile email",
    }).then(_auth0k, _authErr);
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const dispatch = useDispatch();
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(String(email).toLowerCase());
  };
  //Const & Let
    const pinLogIn = async () => {
  localStorage.setItem("mute", false);

  if (String(pinCode).length === 4) {
    setLoader(true);
    try {
      const response = await checkPinCode(pinCode, userId); // отправляем пин на сервер
      if (response.data.success) {
        setNotify({
          isOpen: true,
          message: "Добро пожаловать!",
          type: "success",
        });

        const socket = new WebSocket("wss://sys.chu.kg/ws/online_status/");
        socket.onopen = () => {
          socket.send(JSON.stringify({ command: "connect", user_id: userId }));
          socket.close();
        };

        let response2 = await SendDevice(device);

        setUserId(datainfo.user);
        sendMessage({ user_id: userId });
        dispatch(setUser(datainfo));

        setTimeout(() => {
          window.location.href = `/home/`;
        }, 1000);
      } else {
        setNotify({
          isOpen: true,
          message: "Неправильный Пин-Код",
          type: "error",
          sound: "error",
        });
      }
    } catch (error) {
      setNotify({
        isOpen: true,
        message: "Ошибка сервера. Попробуйте позже.",
        type: "error",
        sound: "error",
      });
    } finally {
      setLoader(false);
    }
  } else {
    setNotify({
      isOpen: true,
      message: "Введите 4-значный ПИН-код",
      type: "warning",
    });
  }
};
  const createUserPin = async () => {
  
    if (String(pinCode)?.length < 4 || !pinCode) {
      setNotify({
        isOpen: true,
        message: "Введите Пин!",
        type: "error",
        sound: "error",
      });
    } else if (String(pinCode).length === 4) {
      try {
        setLoader(true);

        let response = await ChangePin(pinCode);
        dispatch(
          changePinCode({
            pin: pinCode,
          })
        );
        setTimeout(() => {
          setNotify({
            isOpen: true,
            message: "Пин успешно задан",
            type: "success",
            sound: "success",
          });
        }, 1000);

        setNotify({
          isOpen: true,
          message: "Добро пожаловать!",
          type: "success",
          sound: "success",
        });
        setTimeout( async () => {
          
       
        // let response4 = await getTariffSubscription(datainfo);
     
        let response2 = await SendDevice(device);

        setUserId(datainfo.user);
        sendMessage({ user_id: userId });
        dispatch(setUser(datainfo));
        setTimeout(() => {
          
          navigate(`/home/`);
        }, 2000);
      }, 1000);
      } catch (error) {
        setNotify({
          isOpen: true,
          message: "Ошибка",
          type: "error",
          sound: "error",
        });
      }
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
    
      first_name === null ||
      last_name === null ||
     
      number_phone === null ||
      inn === null ||
      password === null
    ) {
      setNotify({
        isOpen: true,
        message: "Заполните все поля!",
        type: "warning",
        sound: "warning",
      });
    } else if( email ===  null || !isValidEmail(email)){
      setNotify({
        isOpen: true,
        message: "Указанная вами электронная почта не верна!",
        type: "warning",
        sound: "warning",
      });
    } 
    else if (inn.length < 5) {
      setNotify({
        isOpen: true,
        message: "ИНН слишком короткий",
        type: "warning",
        sound: "warning",
      });
    } else if (checkPassword !== password) {
      setNotify({
        isOpen: true,
        message: "Пароль не совпадает!",
        type: "warning",
        sound: "warning",
      });
    } else
      try {
        setLoader(true);
        let emailtrash = "free";
        let passwordtrash = "free";
        let responsed = await logintrash(emailtrash, passwordtrash);
        localStorage.setItem("token", responsed.data.access);
        const userIdd = tokenDecode(responsed.data.refresh);
        let userResponsed = await getUserInfo(userIdd);
        const datas = { ...userResponsed.data, token: responsed.data.access };

        dispatch(setUser(datas));

        let response = await createNewUser(
          gender,
          first_name,
          last_name,
          middle_name,
          data_of_birth,
          number_phone,
          email,
          inn,
          password

          // number,
          // issued_by,
          // date_of_issue,
          // date_end
        );
       
        if (response?.data?.message) {
          setNotify({
            isOpen: true,
            message: response?.data?.message,
            type: "error",
            sound: "error",
          });
        }
        else {
          dispatch(
            postRegisterUser({
              gender,
              first_name,
              last_name,
              middle_name,
              data_of_birth,
              number_phone,
              email,
              inn,
              password,
  
              // number,
              // issued_by,
              // date_of_issue,
              // date_end,
            })
          );
          
          // setNotify({
          //   isOpen: true,
          //   message: "Пользователь успешно добавлен!, Авторизуйтесь через ИНН",
          //   type: "success",
          //   sound: "success",
          // });
          const delay = 1000; 
          setTimeout(() => {
            
            // setLoginMail(false);
            const signIn = async (event) => {
              localStorage.removeItem("task");
              localStorage.removeItem("user");
              let responseinfo = await login(inn, password);
           
              localStorage.setItem("token", responseinfo.data.access);
              const userId = tokenDecode(responseinfo.data.refresh);
    
              let userResponse =  await getUserInfo(userId);
              const data = { ...userResponse.data, token: responseinfo.data.access };
         
              //урезал код
              setUserPinCode(data.pin);
              setDataInfo(data)
              setOpenModal(true);
              setUserId(userId);
          
          };
          signIn()
          }, delay);
         
        }
        
      } catch (error) {
        console.log("CHU");

        setNotify({
          isOpen: true,
          message: "Ошибка!",
          type: "error",
          sound: "error",
        });
      } finally {
        setLoader(false);
      }
  };

  const forSelect = useSelector((state) => state.order.position);

  //Consts & Let
  const dataRector = [forSelect];
  const handleInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^\d]/g, '');
    
    setInn(value);
  
  };
  return (
    <>
      <div className={styles.container}>
      
          <h2 className={styles.login__title}>Рады видеть вас в NewTech! 👋🏻</h2>
          <h4  className={styles.login__untitle}>Пожалуйста, заполните свои данные</h4>
        <form action="#">
          <div className={styles.user_details}>
          <div className={styles.input_pox} style={{width:'100%'}}>
              <span className={styles.datails}>ИНН</span>
              <input
                type="number"
                placeholder="ИНН"
                value={inn}
                onChange={handleInputChange}
                required
              />
            </div>
          <div className={styles.input_pox}>
              <span className={styles.datails}>Фамилия</span>
              <input
                type="text"
                placeholder="Фамилия"
                value={last_name}
                onChange={(e) => setLast_name(e.target.value)}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <span className={styles.datails}>Имя</span>
              <input
                type="text"
                placeholder="Имя"
                value={first_name}
                onChange={(e) => setFirst_name(e.target.value)}
                required
              />
            </div>
          
            {/* <div className={styles.input_pox}>
              <span className={styles.datails}>Дата рождения</span>
              <input
                type="date"
                placeholder="Дату рождения"
                value={data_of_birth}
                max={getCurrentDate()}
                onChange={(e) => setData_of_birth(e.target.value)}
                required
              />
            </div> */}
            <div className={styles.input_pox}>
              <span className={styles.datails}>Номер телефона</span>
              <input
                type="number"
                placeholder="Номер телефона"
                value={number_phone}
                onChange={(e) => setNumber_phone(e.target.value)}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <span className={styles.datails}>E-mail</span>
              <input
                type="email"
                placeholder="Электронная почта"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
           
            <div className={styles.input_pox}>
              <span className={styles.datails}>Пароль</span>

              <input
                type={showPassword ? "text" : "password"}
                placeholder="Пароль"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                
              />
              <div src={eye} type="button" className={styles.show__password} onClick={togglePasswordVisibility}>
                {showPassword ? <> <img src={hidden}></img> </> : <> <img src={eye}></img> </>}
              </div>
            </div>
            <div className={styles.input_pox}>
          
              <span className={styles.datails}>Повторите пароль</span>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Пароль"
                value={checkPassword}
                onChange={(e) => setCheckPassword(e.target.value)}
                required
              />
             
            </div>
            {/* <div>
            <span className={styles.gender_title}>Выберите пол</span>
            <div className={styles.gender_details}>
              <div style={{ display: "flex", paddingRight: "25px" }}>
                <input
                  style={{
                    height: "18px",
                    width: "18px",
                    background: "#d9d9d9",
                    borderRadius: "50%",
                    marginRight: "10px",
                    border: "5px solid transparent",
                  }}
                  type="radio"
                  name="gender"
                  id="dot-1"
                  value={gender}
                  onChange={(e) => setGender("Мужчина")}
                  required
                />
                <span className={styles.gender}>Мужчина</span>
              </div>
              <div style={{ display: "flex" }}>
                <input
                  style={{
                    height: "18px",
                    width: "18px",
                    background: "#d9d9d9",
                    borderRadius: "50%",
                    marginRight: "10px",
                    border: "5px solid transparent",
                  }}
                  type="radio"
                  name="gender"
                  id="dot-2"
                  value={gender}
                  onChange={(e) => setGender("Женщина")}
                  required
                />
                <span className={styles.gender}>Женщина</span>
              </div>
              </div>
            </div> */}
          </div>

          {loader ? (
            <ScaleLoader color="black" size={30} />
          ) : (
            <div className={styles.button}>
           
     
              <input
                type="submit"
                onClick={handleSubmit}
                value="Зарегистрироваться"
              />
          
            </div>
          )}
        </form>
        <h4 className={styles.login__untitle} style={{marginTop:"10px"}}>Регистрируясь, вы подтверждаете, что принимаете Пользовательское соглашение, даете Поручение и Согласие на обработку персональных данных.</h4>
        <hr className={styles.hr__line}></hr>
        <div className={styles.div_social} onClick={signIn}>
        Заполнить данные  
            <Button className={styles.sign__google__btns} >
               <img  style={{width:"36px"}}  src={googleIcon} alt="" />
            </Button>
         
          </div>
          <div className={styles.register_footer}>
              У вас уже есть аккаунт?
        
              <button
                className={styles.register_button_create}
                onClick={() => setLoginMail(false)}
              >
                Войти
              </button>
             
          
            </div>
      </div>
     
      <Notification notify={notify} setNotify={setNotify} />
      {userPinCode === null ? (
        <>
          <ModalWindow
            openModal={openModal}
            setOpenModal={setOpenModal}
            modalTitle={
              <>
                <p>
                  Добро пожаловать в <br /> New Technologies!
                </p>
              </>
            }
            modalText={"Придумайте ПИН-код"}
            width={"unset"}
          >
            <PinCode setPinCode={setPinCode} passwordVisible={false} />

            {loader ? (
              <Button
                style={{ width: "unset", border: "none", background: "none" }}
              >
                <ScaleLoader color="black" size={15} />
              </Button>
            ) : (
              <>
                <Button
                  onClick={() => setOpenModal(false)}
                  className={styles.btn_pin_close}
                >
                  Закрыть
                </Button>
                <Button
                  style={{ width: "unset" }}
                  onClick={createUserPin}
                  className={styles.btn_pin}
                >
                  Сохранить
                </Button>
              </>
            )}
          </ModalWindow>{" "}
        </>
      ) : (
        <ModalWindow
          openModal={openModal}
          setOpenModal={setOpenModal}
          modalText={"Введите ПИН-код"}
          width={"unset"}
        >
          <>
            <PinCode setPinCode={setPinCode} passwordVisible={false} />
            <Button
              onClick={() => setOpenModal(false)}
              className={styles.btn_pin_close}
            >
              {" "}
              Закрыть
            </Button>
            <Button onClick={pinLogIn} className={styles.btn_pin}>
              Войти
            </Button>
          </>
          <div className={styles.div_register_button} style={{marginTop:'5px'}}>
          <p
              className={styles.register_button_reset}
              onClick={() => RecoverPin()}
              style={{ margin: "0px 10px 0px 0" }}
            >
              Забыли пин?
              {/* <img src={rostok} className={styles.size} alt="" /> */}
            </p>
         </div>
        </ModalWindow>
      )}
    </>
  );
};

export default RegisterForTest;
